import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useData } from "../context/DataContext";
import { resolveImageUrl } from "../admin/ImageUpload";
import { toast } from "sonner";
import { ArrowLeft, Mail as MailIcon, Loader2 } from "lucide-react";

const ParentForgotPassword = () => {
  const { settings } = useData();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const logo = resolveImageUrl(settings?.logo);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/parent/auth/forgot-password", { email });
      toast.success(data?.message || "Email envoyé si le compte existe.");
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur, réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="parent-forgot-page">
      <div className="py-5 px-6">
        <Link to="/espace-famille/login" className="inline-flex items-center gap-1 text-stone-600 hover:text-deep-rose text-sm">
          <ArrowLeft size={14} /> Retour à la connexion
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-12">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 sm:p-10">
          <div className="text-center mb-8">
            {logo ? (
              <img src={logo} alt="L'Élan Danse" className="h-20 mx-auto object-contain" />
            ) : (
              <div className="flex flex-col leading-none items-center">
                <span className="font-script text-5xl text-deep-rose">L&apos;élan</span>
                <span className="font-script text-4xl text-deep-rose -mt-1">Danse</span>
              </div>
            )}
            <p className="mt-3 text-xs uppercase tracking-widest text-stone-500">Mot de passe oublié</p>
          </div>

          {sent ? (
            <div className="text-center space-y-4" data-testid="parent-forgot-sent">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blush-light text-deep-rose">
                <MailIcon size={24} />
              </div>
              <p className="text-stone-700 text-sm leading-relaxed">
                Si un compte existe pour cet email, un lien de réinitialisation vient d&apos;être envoyé.<br />
                Pensez à vérifier vos spams.
              </p>
              <Link to="/espace-famille/login" className="inline-block text-deep-rose text-sm underline">
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-5" data-testid="parent-forgot-form">
              <p className="text-sm text-stone-600 leading-relaxed">
                Saisissez votre email. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>
              <div>
                <label className="block text-sm uppercase tracking-widest text-stone-500 mb-2">Email</label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  name="email"
                  autoComplete="email"
                  inputMode="email"
                  required
                  data-testid="parent-forgot-email"
                  className="w-full bg-cream rounded-xl border border-blush-light px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blush"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="parent-forgot-submit"
                className="w-full bg-coral text-white py-3 rounded-full font-serif-display tracking-widest uppercase text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50"
              >
                {loading ? <Loader2 className="animate-spin" size={16} /> : <MailIcon size={16} />}
                {loading ? "Envoi..." : "Envoyer le lien"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParentForgotPassword;
